import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.healthCheckProgress.loading;
export const healthCheckProgressErrorMessage = (state: RootState) =>
  state.healthCheckProgress.error;
export const healthCheckProgressDataResponse = (state: RootState) =>
  state.healthCheckProgress.healthCheckProgressResponse;
